// Commission adjustment DAO — CRUD for commission_adjustments.

import { BaseDao, type SupabaseClient, type MutationOptions } from '../base.ts';
import type { CommissionAdjustment } from '@shared/types/commission.ts';

export class CommissionAdjustmentDao extends BaseDao<CommissionAdjustment> {
  protected readonly dependentResources = ['commission_adjustments'];

  constructor(sb: SupabaseClient) {
    super(sb, 'commission_adjustments');
  }

  async listForMonth(payeeId: number, reportMonth: string): Promise<CommissionAdjustment[]> {
    const { data, error } = await this.sb
      .from('commission_adjustments')
      .select('*')
      .eq('payee_id', payeeId)
      .eq('report_month', reportMonth)
      .eq('is_deleted', false)
      .order('created_at');
    if (error) throw error;
    return (data ?? []) as CommissionAdjustment[];
  }

  async add(
    payeeId: number,
    reportMonth: string,
    amountPln: number,
    reason: string,
    createdBy: number | null,
    opts?: MutationOptions,
  ): Promise<CommissionAdjustment> {
    return this.create(
      { payee_id: payeeId, report_month: reportMonth, amount_pln: amountPln, reason, created_by: createdBy },
      opts,
    );
  }

  async softDelete(id: number, opts?: MutationOptions): Promise<void> {
    await this.update(id, { is_deleted: true } as Partial<CommissionAdjustment>, opts);
  }
}
